(function () {
  function initSection(root) {
    var video = root.querySelector('[data-fullwidth-video-sound-video]');
    var cta = root.querySelector('[data-fullwidth-video-sound-cta]');
    if (!video || !cta) return;

    var label = cta.querySelector('[data-fullwidth-video-sound-label]');
    var iconMuted = cta.querySelector('[data-fullwidth-video-sound-icon-muted]');
    var iconUnmuted = cta.querySelector('[data-fullwidth-video-sound-icon-unmuted]');

    var labelUnmute = cta.getAttribute('data-label-unmute') || '';
    var labelMute = cta.getAttribute('data-label-mute') || '';
    var ariaUnmute = cta.getAttribute('data-aria-unmute') || '';
    var ariaMute = cta.getAttribute('data-aria-mute') || '';

    function syncUI() {
      var muted = video.muted;
      if (label) {
        label.textContent = muted ? labelUnmute : labelMute;
      }
      cta.setAttribute('aria-label', muted ? ariaUnmute : ariaMute);
      if (iconMuted) {
        iconMuted.hidden = !muted;
      }
      if (iconUnmuted) {
        iconUnmuted.hidden = muted;
      }
      cta.classList.toggle('fullwidth-video-sound__cta--unmuted', !muted);
    }

    cta.addEventListener('click', function () {
      video.muted = !video.muted;
      if (!video.muted) {
        var playPromise = video.play();
        if (playPromise && typeof playPromise.then === 'function') {
          playPromise.catch(function () {});
        }
      }
      syncUI();
    });

    video.addEventListener('volumechange', syncUI);

    var autoplay = video.play();
    if (autoplay && typeof autoplay.then === 'function') {
      autoplay.catch(function () {});
    }

    syncUI();
  }

  document.querySelectorAll('[data-fullwidth-video-sound]').forEach(initSection);
})();
